import { useState } from "react";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { TransactionForm } from "./TransactionForm";
import { api, errMsg } from "../lib/api";

export const AddTransactionDialog = ({ statementId, onAdded }) => {
  const [open, setOpen] = useState(false);
  const submit = async (body) => {
    try {
      const tx = await api.addTransaction(statementId, body);
      toast.success("Buchung hinzugefügt");
      setOpen(false);
      onAdded(tx);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <Button variant="outline" onClick={() => setOpen(true)} data-testid="add-transaction-btn" className="gap-1.5">
        <Plus className="h-4 w-4" /> Buchung hinzufügen
      </Button>
      <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-lg" data-testid="add-transaction-dialog">
        <DialogHeader>
          <DialogTitle>Fehlende Buchung hinzufügen</DialogTitle>
          <DialogDescription>Leere Position = am Ende einfügen. Für eine Stelle zwischen Buchung 3 und 4 z. B. 3,5 eingeben.</DialogDescription>
        </DialogHeader>
        <TransactionForm tx={{}} onSubmit={submit} submitLabel="Buchung hinzufügen" testId="add-transaction-form" />
      </DialogContent>
    </Dialog>
  );
};
